'use client'

// React Imports
import { useEffect, useRef } from 'react'
import type { CSSProperties } from 'react'

import { Source_Serif_4 } from 'next/font/google'

// TODO uncomment code to be used in future // Third-party Imports
// import styled from '@emotion/styled'

// Type Imports
// import type { VerticalNavContextProps } from '@menu/contexts/verticalNavContext'

// Component Imports
import MaterioLogo from '@core/svg/Logo'

// Hook Imports
import useVerticalNav from '@menu/hooks/useVerticalNav'
import { useSettings } from '@core/hooks/useSettings'

const sourceSerif = Source_Serif_4({
  weight: ['400', '600'],
  style: ['normal', 'italic'],
  subsets: ['latin'],
  display: 'swap'
})

// TODO  uncomment code to be used in future
// type LogoTextProps = {
//   isHovered?: VerticalNavContextProps['isHovered']
//   isCollapsed?: VerticalNavContextProps['isCollapsed']
//   transitionDuration?: VerticalNavContextProps['transitionDuration']
//   isBreakpointReached?: VerticalNavContextProps['isBreakpointReached']
//   color?: CSSProperties['color']
// }

// const LogoText = styled.span<LogoTextProps>`
//   color: ${({ color }) => color ?? 'var(--mui-palette-text-primary)'};
//   font-size: 1.25rem;
//   line-height: 1.2;
//   font-weight: 600;
//   letter-spacing: 0.15px;
//   text-transform: uppercase;
//   transition: ${({ transitionDuration }) =>
//     `margin-inline-start ${transitionDuration}ms ease-in-out, opacity ${transitionDuration}ms ease-in-out`};

//   ${({ isHovered, isCollapsed, isBreakpointReached }) =>
//     !isBreakpointReached && isCollapsed && !isHovered
//       ? 'opacity: 0; margin-inline-start: 0;'
//       : 'opacity: 1; margin-inline-start: 10px;'}
// `

const Logo = ({}: { color?: CSSProperties['color'] }) => {
  // Refs
  const logoTextRef = useRef<HTMLSpanElement>(null)

  // Hooks
  const { isHovered, isBreakpointReached } = useVerticalNav()
  const { settings } = useSettings()

  // Vars
  const { layout } = settings

  useEffect(() => {
    if (layout !== 'collapsed') {
      return
    }

    if (logoTextRef && logoTextRef.current) {
      if (!isBreakpointReached && layout === 'collapsed' && !isHovered) {
        logoTextRef.current?.classList.add('hidden')
      } else {
        logoTextRef.current.classList.remove('hidden')
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isHovered, layout, isBreakpointReached])

  return (
    <div className='flex items-center min-bs-[24px]'>
      <MaterioLogo className='text-[22px] text-primary' />
      {/* <LogoText
        color={color}
        ref={logoTextRef}
        isHovered={isHovered}
        isCollapsed={layout === 'collapsed'}
        transitionDuration={transitionDuration}
        isBreakpointReached={isBreakpointReached}
      >
        {themeConfig.templateName}
      </LogoText> */}

      <h1
        className={`${sourceSerif.className} ps-2 leading-[15px] group-[.ts-horizontal-layout-navbar-content]:leading-[0.55] pt-1 mt-0`}
      >
        <span className='text-[28px] font-semibold'>Mirror</span>
        <br />
        <span className='text-[16px] font-normal tracking-[.25em]'>Security</span>
      </h1>
    </div>
  )
}

export default Logo
